import { useState, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import { adsMemberApi, generateClientRequestId } from '../../api/adsMemberApi';
import './ads.css';

export default function PromotionCreatePage() {
  const { t } = useTravelTranslation();
  const navigate = useNavigate();
  const clientRequestIdRef = useRef(generateClientRequestId());

  const [sourceContentId, setSourceContentId] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!sourceContentId.trim()) {
      setError('請填寫來源行程 ID');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      const res = await adsMemberApi.promotions.create({
        sourceContentType: 'JOURNEY_PUBLICATION',
        sourceContentId: sourceContentId.trim(),
        clientRequestId: clientRequestIdRef.current,
      });
      navigate(`/me/ads/promotions/${res.promotionApplicationId}`);
    } catch (err) {
      setError(err?.message || '建立推廣申請失敗');
      setSubmitting(false);
    }
  };

  return (
    <main className="ads-page" data-testid="promotion-create-page">
      <header className="ads-header">
        <h1 className="ads-title">{t('travel.ads.promotions.create')}</h1>
        <Link to="/me/ads" className="ads-btn ads-btn--secondary" data-testid="btn-back-ads">
          {t('travel.ads.common.backToAds')}
        </Link>
      </header>

      {error ? (
        <div className="ads-alert ads-alert--error" data-testid="promotion-create-error">
          {error}
        </div>
      ) : null}

      <form className="ads-form" onSubmit={handleSubmit} data-testid="promotion-create-form">
        <div className="ads-form-group">
          <label className="ads-form-label" htmlFor="sourceContentId">
            來源公開行程 ID (sourceContentId)
          </label>
          <input
            id="sourceContentId"
            type="text"
            className="ads-form-input"
            value={sourceContentId}
            onChange={(e) => setSourceContentId(e.target.value)}
            placeholder="例如: 12345678901234567"
            disabled={submitting}
            data-testid="input-source-content-id"
          />
        </div>

        <div>
          <button
            type="submit"
            className="ads-btn ads-btn--primary"
            disabled={submitting}
            data-testid="btn-submit-promotion-create"
          >
            {submitting ? t('travel.ads.common.submitting') : t('travel.ads.common.save')}
          </button>
        </div>
      </form>
    </main>
  );
}
